import { Model } from '@vuex-orm/core';

export default class DeliveryPeriod extends Model {
    static entity = 'deliveryperiods';

    static fields() {
        return {
            id: this.increment(),
            sortOrder: this.number(),
            displayText: this.string(''),
            deliveryPeriodType: this.number(),
            dateFrom: this.string(''),
            dateUntil: this.string(''),
        }
    }
}